export { default as DeckPlan } from './DeckPlanContainer.vue';
